import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { StyledInputsContainer } from './styles';

const SuggestForm = ({ collections, control, errors }) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledInputsContainer>
        <Box>
          <FormControl
            fullWidth
            variant="outlined"
            size="small"
            error={!!errors?.settings?.suggest?.collection}
          >
            <InputLabel>{t('search.collection', { ns: 'fields' })}</InputLabel>
            <Controller
              name="settings.suggest.collection"
              control={control}
              render={({ field }) => (
                <Select
                  label={t('search.collection', { ns: 'fields' })}
                  inputProps={{ 'aria-label': 'collection' }}
                  {...field}
                >
                  {collections.map((collection) => (
                    <MenuItem key={collection} value={collection}>
                      {collection}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            <FormHelperText>
              {errors?.settings?.suggest?.collection?.message}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box>
          <Controller
            name="settings.suggest.requestHandler"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                label={t('search.requestHandler', { ns: 'fields' })}
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{ 'aria-label': 'suggest request handler' }}
                error={!!errors?.settings?.suggest?.RequestHandler}
                helperText={errors?.settings?.suggest?.RequestHandler?.message}
              />
            )}
          />
        </Box>
        <Box>
          <Controller
            name="settings.suggest.dictionary"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                label={t('search.dictionary', { ns: 'fields' })}
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{ 'aria-label': 'suggest dictionary' }}
                error={!!errors?.settings?.suggest?.dictionary}
                helperText={errors?.setting?.suggest?.dictionary?.message}
              />
            )}
          />
        </Box>
      </StyledInputsContainer>
    </>
  );
};

SuggestForm.propTypes = {
  collections: PropTypes.array,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

export default SuggestForm;
